import React from "react";
// import franjainf from '../assets/images/logos/franja_inferior.png'
import franjainf from '../assets/images/logos/franjaInf.svg'

const FlightTicket = ({flightType, flightColor, passenger, date, from, to, flightNum, departure, arrival, seat}) => {

    const formattedDate = new Date(date).toLocaleDateString("es-ES", {
        year: "numeric",
        month: "short",
        day: "numeric",
    });

    const formattedHours = (time) => {
        return new Date(time).toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: "America/Mexico_City"
        });
    };

    return (
        /* Outer Container: Fixed height */
        <div className="outerTicket my-2 p-0" style={{ height: "70vh", borderRadius: "12px", backgroundColor: "#01153a", overflow: "hidden", display: "flex", flexDirection: "column" }}>

            {/* Top Bar: 10% */}
            <div className="row m-0 p-0" style={{ backgroundColor: flightColor, height: "10%", flexShrink: 0 }}>
                <div className="col d-flex justify-content-center align-items-center m-0 p-0">
                    <h5 className="text-white text-center m-0 p-0">{flightType} FLIGHT</h5>
                </div>
            </div>

            {/* First Part: 45% */}
            <div className="row m-0 pt-1 px-2 pb-0" style={{ height: "40%", borderBottom: "2px dashed white" }}>
                <div className="col-12 m-0 p-0">
                    <div className="row m-0 pb-2">
                        <div className="col m-0 p-0">
                            <p className="text-white ps-2 mb-0">Passenger:</p>
                            <p className="text-white ps-2 mb-0">{passenger}</p>
                        </div>
                    </div>

                    <div className="row m-0 mt-1 p-0 align-items-center">
                        <div className="col text-center pe-1"><h3 className="text-white">{from}</h3></div>
                        <div className="col text-center"><p className="text-white">---</p></div>
                        <div className="col text-center"><h4 className="text-white">✈</h4></div>
                        <div className="col text-center"><p className="text-white">---</p></div>
                        <div className="col text-center ps-1"><h3 className="text-white">{to}</h3></div>
                    </div>

                    <div className="row m-0 mt-2 p-0">
                        <div className="col">
                            <p className="text-white m-0">Flight Number:</p>
                            <h1 style={{ color: "#007fff" }}>{flightNum}</h1>
                        </div>
                        <div className="col m-0 p-0">
                            <p className="text-white m-0">Flight Date:</p>
                            <p className="text-white mb-0">{formattedDate}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Second Part: 45% - Fixed Height Issue */}
            <div className="row m-0 p-0" style={{ height: "50%" }}>
                <div className="col-12 d-flex flex-column justify-content-between p-0 m-0" style={{ height: "100%" }}>
                    
                    {/* Departure/Arrival Section */}
                    <div className="row m-0 pt-3" style={{ flex: 1 }}>
                        <div className="col d-flex flex-column justify-content-center align-items-center">
                            <p className="text-white mb-1">Departure</p>
                            <h2 className="text-white m-0">{formattedHours(departure)}</h2>
                        </div>
                        <div className="col d-flex flex-column justify-content-center align-items-center" style={{ borderLeft: "1px solid white" }}>
                            <p className="text-white mb-1">Arrival</p>
                            <h2 className="text-white m-0">{formattedHours(arrival)}</h2>
                        </div>
                    </div>

                    {/* Footer Section: Image and Seat */}
                    <div className="row m-0 align-items-center pe-3" style={{ height: "40%" }}>
                        <div className="col-8 px-0 pb-2">
                            <img src={franjainf} alt="decoration" style={{ width: "80%", height: "auto" }} />
                        </div>
                        <div className="col-4 d-flex flex-column justify-content-center align-items-center" style={{ border: "1px solid gray", borderRadius: "12px", height: "70%" }}>
                            <p className="text-white m-0" style={{ fontSize: "0.8rem" }}>Seat</p>
                            <h2 className="text-white m-0">{seat}</h2>
                        </div>
                    </div>

                </div>
            </div>
        </div> /* End of outerTicket */
    );
}

export default FlightTicket;